import { isPast, parse } from 'date-fns';
import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';

function VendorInsurace() {
  const vendor = useOutletContext();

  if (!vendor.insurance) return null;

  const expireDate = parse(
    vendor.insuranceExpireDate,
    'yyyy-MM-dd',
    new Date()
  );
  const isExpired = isPast(expireDate);
  return (
    <div className="px-4 py-3 mb-1" style={{ marginInline: '-24px' }}>
      <h5 className="mb-3">Insurance</h5>
      {isExpired ? (
        <Alert variant="warning">Insurance expired</Alert>
      ) : (
        <Alert
          className="w-100 d-flex flex-column flex-sm-row gap-3 align-items-sm-center justify-content-between"
          variant="info"
        >
          <span>
            Insurance expires on:{' '}
            <strong>{expireDate.toLocaleDateString('en-US')}</strong>
          </span>

          <Button
            as="a"
            href={vendor.insurance}
            target="_blank"
            rel="noreferrer"
            download
          >
            Download
          </Button>
        </Alert>
      )}
    </div>
  );
}

export default VendorInsurace;
